<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="160px" :rules="rules">
          <el-form-item label="用户名/手机号" prop="UserName">
            <el-input
              v-model="form.UserName"
              placeholder="用户名/手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              show-password
              v-model="form.newPwd"
              placeholder="请输入密码"
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="RealName">
            <el-input
              v-model="form.RealName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      loading: false,
      form: {
        UserName: '',
        newPwd: '',
        RealName: '',

        ProjectId: '',
      },
      rules: {
        UserName: [
          {
            required: true,
            message: '请输入用户名/手机号',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/ // 手机号正则
              if (value && !reg.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        newPwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        RealName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
      },
      drawer: false,
    }
  },
  props: {},
  components: {},
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        this.loading = true
        this.$http
          .post('/Base_Manage/Home/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.form = {
        UserName: '',
        newPwd: '',
        RealName: '',
        ProjectId: this.$ProjectId,
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base_Manage/Home/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
</style>
